module.exports = __webpack_public_path__ + "img/classes1.cbac8e36.png";